import { useEffect, useState } from "react";
import { getGradableModels } from "../gradableModels/functions";

/** Modelos ligados à arte (`art.gradableModels`, ids), na ordem do documento; o que falhar sai da lista. */
export function useLinkedModels(token, ids) {
    const key = (ids || []).map((id) => String(id?._id || id)).filter(Boolean).join(",");
    const [models, setModels] = useState([]);
    useEffect(() => {
        let cancelled = false;
        const list = key ? key.split(",") : [];
        if (!list.length) {
            setModels([]);
            return undefined;
        }
        Promise.all(list.map((id) => getGradableModels(token, id)
            .then((out) => (out?.type === "success" ? (out.data || [])[0] || null : null))
            .catch(() => null)))
            .then((found) => { if (!cancelled) setModels(found.filter(Boolean)); });
        return () => { cancelled = true; };
    }, [token, key]);
    return models;
}
